document.addEventListener('click', function (e) {
  const offcanvas = document.getElementById('purpleOffcanvas');
  const backdrop = document.getElementById('purpleOffcanvasBackdrop');

  if (!offcanvas || !backdrop) return;

  const toggleBtn = e.target.closest('.mobile-menu-toggle');
  if (toggleBtn) {
    e.preventDefault();
    if (offcanvas.parentElement !== document.body) {
      document.body.appendChild(backdrop);
      document.body.appendChild(offcanvas);
    }
    offcanvas.classList.add('show');
    backdrop.classList.add('show');
    document.body.style.overflow = 'hidden';
    return;
  }

  const closeBtn = e.target.closest('#purpleOffcanvasClose');
  if (closeBtn || e.target === backdrop) {
    e.preventDefault();
    offcanvas.classList.remove('show');
    backdrop.classList.remove('show');
    document.body.style.overflow = '';
    return;
  }
});
